<div class="qBank dialog-wrapper">
  <div class="modal-header">
    <h5 class="modal-title">Search & Associate Evaluator</h5>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="px-5 py-3 batch-evaluation">
    <div class="dialog-body">
      <span class="GR-18 text-wrap mt-3">
        Adding Evaluator to {{ batchDetails.stageName }}
      </span>

      <div class="mt-4">
        <form [formGroup]="searchForm" (ngSubmit)="getAvailableEvaluator()">
          <div class="row">
            <div class="col-4">
              <div class="d-flex mb-3">
                <label for="addcategory" class="me-3 mt-2" style="width: 120px">
                  Search By :
                </label>

                <select
                  id="score"
                  name="score"
                  class="form-control"
                  formControlName="type"
                >
                  <option *ngFor="let item of searchList" [value]="item.value">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-5">
              <div class="d-flex mb-3">
                <label for="addcategory" class="me-3 mt-2" style="width: 90px">
                  Search Text :
                </label>

                <div class="input-wrapper">
                  <input
                    class="form-control"
                    type="text"
                    formControlName="text"
                    placeholder="Search Text"
                  />

                  @if (searchForm.get("text").value) {
                  <span class="clear-icon" (click)="clearSearch()">×</span>
                  }
                </div>
              </div>
            </div>
            <div class="col-2">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>
        </form>

        <hr class="custom-horizontal-line" />

        @if(evaluators.length>0){
        <table class="table table-bordered table-striped my-4">
          <thead>
            <tr>
              <th style="width: 100px">
                <input
                  type="checkbox"
                  [(ngModel)]="allSelected"
                  (change)="toggleAll()"
                />
              </th>
              <th>Evaluator Name</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of evaluators; let i = index">
              <td>
                <input
                  type="checkbox"
                  [(ngModel)]="item.isSelected"
                  (change)="updateSelection()"
                />
              </td>
              <td>{{ item.firstName }} {{ item.lastName }}</td>
            </tr>
          </tbody>
        </table>

        <!-- <div class="row my-5">
        <div class="col text-center">
          <button
            type="button"
            [hidden]="!isLoadmore"
            class="btn btn-more mtop15"
          >
            Load more
          </button>
        </div>
      </div> -->

        } @else{

        <div *ngIf="noDataFoundFlag" class="text-center mt-5">
          <img class=" " src="/assets/img/Create-Questions-2.png" alt="" />
          <p class="mt-3 mb-3 RR-16">No Matching Record Found</p>
        </div>

        <!-- <div *ngIf="!noDataFoundFlag" class="empty-box my-5">
          <div class="empty-content">
            <div class="empty-icon">🧑‍💼</div>
            <h5>No Evaluators Associated to this Stage Yet</h5>
          </div>
        </div> -->

        }
      </div>
    </div>
  </div>

  @if(evaluators.length > 0){
  <div class="dialog-footer text-center my-4">
    <button
      type="button"
      class="btn btn-primary"
      data-dismiss="modal"
      (click)="assignEvaluator()"
      [disabled]="!isAnyEvaluatorSelected()"
    >
      Associate Evaluator
    </button>
    <button
      type="button"
      (click)="closeModal()"
      class="btn btn-cancel"
      data-dismiss="modal"
    >
      Cancel
    </button>
  </div>
  }
</div>
